var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg7610",
    viewBox: "1719.858 6177.276 47.14 47.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7591"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y1: 0.919,
    y2: 1.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop7575",
    offset: 0,
    stopColor: "#a8a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop7577",
    offset: 1,
    stopColor: "#545554"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    width: 47.14,
    height: 47.14,
    x: 1719.858,
    y: 6177.276,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset7580"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur7582",
    result: "blur",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood7584",
    floodOpacity: 0.322
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite7586",
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite7588",
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style7573"
  }, ".cls-3{fill:#3c3c3c}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium_Motor",
    "data-name": "Medium Motor",
    transform: "translate(1346 5554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(375.358 624.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    fill: "url(#linear-gradient)",
    d: "M3.281-.287h39a2.357 2.357 0 0 1 2.57 1.972v40.348c0 1-1.1 1.82-2.57 1.82h-39c-1.473 0-2.57-.815-2.57-1.82V1.685a2.357 2.357 0 0 1 2.57-1.972Z",
    "data-name": "Path 1",
    transform: "translate(-.711 .287)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "rotate(90 -102.639 522.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7596",
    filter: "url(#Union_1)",
    transform: "rotate(-90 -2206.64 3972.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    fill: "#a8a9a8",
    d: "M21.236 44.14a6.219 6.219 0 0 1-6.219-6.219v-8.8h-8.8A6.219 6.219 0 0 1 0 22.9v-1.664a6.219 6.219 0 0 1 6.219-6.219h8.8v-8.8A6.219 6.219 0 0 1 21.236 0H22.9a6.219 6.219 0 0 1 6.219 6.219v8.8h8.8a6.219 6.219 0 0 1 6.219 6.219V22.9a6.219 6.219 0 0 1-6.219 6.219h-8.8v8.8A6.219 6.219 0 0 1 22.9 44.14Z",
    "data-name": "Union 1",
    transform: "rotate(90 -2206.64 3972.14)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 4.854,
    cy: 4.854,
    r: 4.854,
    className: "cls-3",
    "data-name": "Ellipse 1",
    transform: "translate(17.292 1.517)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 4.854,
    cy: 4.854,
    r: 4.854,
    className: "cls-3",
    "data-name": "Ellipse 2",
    transform: "translate(17.292 32.915)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    cx: 4.854,
    cy: 4.854,
    r: 4.854,
    className: "cls-3",
    "data-name": "Ellipse 1",
    transform: "rotate(-90 14.183 12.665)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    cx: 4.854,
    cy: 4.854,
    r: 4.854,
    className: "cls-3",
    "data-name": "Ellipse 2",
    transform: "rotate(-90 29.881 -3.034)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    fill: "#b72b1c",
    stroke: "#8b1104",
    strokeWidth: 0.25,
    "data-name": "Ellipse 4",
    transform: "translate(390.903 640.17)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse7603",
    cx: 6.752,
    cy: 6.752,
    r: 6.752,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse7605",
    cx: 6.752,
    cy: 6.752,
    r: 6.627,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hole",
    d: "M5606.437 962.413s-.054 1.021-.769 1.029-1.461 0-1.461 0a2.363 2.363 0 0 0-.455 1.691c0 1.266.357 1.6.357 1.6h1.628a.645.645 0 0 1 .7.7v1.667a3.882 3.882 0 0 0 1.766.287 6.459 6.459 0 0 0 1.676-.287v-1.667a.73.73 0 0 1 .734-.7 10.674 10.674 0 0 0 1.444-.14s.4-.374.434-1.632-.353-1.644-.353-1.644h-1.693a.641.641 0 0 1-.762-.678 11.41 11.41 0 0 1 0-1.643 4.815 4.815 0 0 0-3.246 0c-.017.698 0 1.417 0 1.417Z",
    transform: "translate(-5210.486 -318.186)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorM);
export default __webpack_public_path__ + "static/media/motorM.6dabd58cacf5d4baa54380d2a2bcf141.svg";
export { ForwardRef as ReactComponent };